import { render } from "./TheMyCollectionModalWindow.vue?vue&type=template&id=3de3e2c5&scoped=true&ts=true"
import script from "./TheMyCollectionModalWindow.vue?vue&type=script&lang=ts"
export * from "./TheMyCollectionModalWindow.vue?vue&type=script&lang=ts"

import "./TheMyCollectionModalWindow.vue?vue&type=style&index=0&id=3de3e2c5&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src186255619/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3de3e2c5"]])

export default __exports__